// Runtime instance config — lets ONE prebuilt SPA bundle serve every
// instance. The instance's web server serves /env.js (written at provision
// time) which sets window.__KIT_ENV__ with the per-instance values that used
// to be baked in at build time (public URL, anon key, upload API). Build-time
// REACT_APP_* vars remain as fallbacks so dev servers and single-instance
// builds work unchanged.
const runtime = (typeof window !== 'undefined' && window.__KIT_ENV__) || {};

export const kitEnv = (key, fallback = '') => {
  const v = runtime[key];
  return v === undefined || v === null || v === '' ? fallback : v;
};

// The instance's display name: runtime env.js (`APP_NAME`, written at
// provision time), else the build-time REACT_APP_APP_NAME, else 'starter'.
// One source for the navbar, login card, drop page and document title.
export const APP_NAME = kitEnv('APP_NAME', process.env.REACT_APP_APP_NAME || 'starter');
